import Parse from "parse"
import { actionWithLoader, onEnter, push } from "../Utils/utils"
import { loadEnterprises, loadAvailableDCs } from "./Enterprise"

export const loadDeliveries = () =>
  actionWithLoader(async (dispatch) => {
    try {
      const deliveries = await Parse.Cloud.run("loadDeliveries")
      dispatch({ type: "DELIVERIES_LOADED", deliveries })
    } catch (e) {
      dispatch({ type: "DELIVERIES_LOAD_FAILED" })
      throw e
    }
  })

export const createDeliveries = (values) =>
  actionWithLoader(async (dispatch) => {
    const created = await Parse.Cloud.run("createDeliveries", {
      enterpriseId: values.enterpriseId,
      slots: values.slots,
    })
    dispatch({ type: "DELIVERIES_CREATED", deliveries: created })
    return { created }
  })

export const onDeliveryMenusEnter = (store) =>
  onEnter({
    store,
    actionThunk: () =>
      actionWithLoader(async (dispatch) => {
        await Promise.all([
          dispatch(loadDeliveries()),
          dispatch(loadEnterprises()),
          dispatch(loadAvailableDCs()),
        ])
      }),
  })

export const showDeliveryMenus = () => push("/organizations/delivery-menus")

export const showDeliveryMenuRecipe = (deliveryIds) =>
  push(`/organizations/delivery-menus/recipe?deliveryIds=${deliveryIds.map(encodeURIComponent).join(",")}`)
